/* eslint-disable react/no-danger */
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { exportDocument } from 'services/actions/dr_licita_actions';
import { DocumentState } from 'store/modules/dr_licita_store/types';
import { BlockTitle, Container } from './styles';

interface EditorViewModalProps {
  modalEditorOpened: boolean;
  setModalEditorOpened: React.Dispatch<React.SetStateAction<boolean>>;
  documentTemplate: DocumentState | undefined;
}

const EditorViewModal = (props: EditorViewModalProps) => {
  const { modalEditorOpened, setModalEditorOpened, documentTemplate } = props;

  return (
    <Modal size="xl" show={modalEditorOpened}>
      <div className="modal-header">
        <h5 className="modal-title text-nowrap">
          <strong>Visualização da petição</strong>
        </h5>
        <button
          aria-label="Close"
          className="close"
          data-dismiss="modal"
          type="button"
          onClick={() => setModalEditorOpened(false)}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div className="modal-body p-0">
        {/* Texto da petição fora das gravações do Clarity */}
        <Container className="p-4" data-clarity-mask="True">
          <h5 className="text-center mb-4">{documentTemplate?.title}</h5>
          {documentTemplate?.blocks?.map((block) => (
            <div key={block.bloc_cd_id || block.bloc_tx_title}>
              {block.bloc_tx_title && <BlockTitle>{block.bloc_tx_title}</BlockTitle>}
              <div
                dangerouslySetInnerHTML={{
                  __html: block.bloc_tx_body || '',
                }}
              />
            </div>
          ))}
        </Container>
      </div>
      <div className="modal-footer justify-content-center">
        <button
          type="button"
          className="btn btn-sm btn-primary"
          data-dismiss="modal"
          onClick={() =>
            exportDocument(documentTemplate?.id || 0, documentTemplate?.title || '', 'pdf')
          }
        >
          Exportar para .pdf
        </button>
        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={() =>
            exportDocument(documentTemplate?.id || 0, documentTemplate?.title || '', 'docx')
          }
        >
          Exportar para .docx
        </button>
      </div>
    </Modal>
  );
};

export default EditorViewModal;
